import API from './apiClient';

export const fetchSkills = () => API.get('/skills');
export const createSkill = (newSkill) => API.post('/skills', newSkill);
export const updateSkill = (id, updatedSkill) => API.put(`/skills/${id}`, updatedSkill);
export const deleteSkill = (id) => API.delete(`/skills/${id}`);
